import styled from '@emotion/styled';
import { Icon } from '@mdi/react';
import { BaseButton, Variables } from '../../base';
import { MessagingAuthorType } from '../util';

interface IAuthorType {
    type?: keyof typeof MessagingAuthorType;
}

export const Header = styled.div`
    display: flex;
    align-items: center;
    background-color: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    padding: 16px 24px 17px;
`;

export const HeaderLabels = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    gap: 8px;
`;

export const AuthorType = styled.div<IAuthorType>`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.regular};
    line-height: 1.33;

    color: ${(props: IAuthorType): string => {
        switch (props.type) {
            case MessagingAuthorType.SUPPORT:
                return Variables.Colors.b300;
            case MessagingAuthorType.PATIENT:
                return Variables.Colors.r30;
            case MessagingAuthorType.PROVIDER:
                return Variables.Colors.subG30;
            default:
                throw new Error(`Unknown AuthorType ${props.type}`);
        }
    }};
`;

export const Author = styled.div`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.semibold};
    line-height: 1.4;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.n100};
`;

export const Value = styled.span`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.semibold};
    line-height: 20px;
    color: #1e293b;
`;

export const Avatar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 9999px;
    background-color: #cbd5e1;
    font-size: 14px;
    font-weight: ${Variables.FontWeight.semibold};
    color: #334155;
    line-height: 20px;
    flex-shrink: 0;
`;

export const BackButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 0;
    margin-right: 12px;
    cursor: pointer;
    color: #94a3b8;
    transition: color 0.2s ease;
    
    &:hover {
        color: #64748b;
    }
`;

export const CloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    color: #94a3b8;
    transition: color 0.2s ease;
    
    &:hover {
        color: #64748b;
    }
`;

export const CloseIcon = styled(Icon)``;

export const BackIcon = styled(Icon)``;
